import type Store from '@ember-data/store';
import type { ModelSchema } from '@ember-data/store/types';
import ApplicationSerializer from 'lumen/serializers/application';

export default class IssueSerializer extends ApplicationSerializer {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  modelNameFromPayloadKey() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.modelNameFromPayloadKey('parity-manager/issue');
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalizeResponse(
    store: Store,
    primaryModelClass: ModelSchema,
    payload: { results: Record<string, object> },
    id: string,
    requestType: string,
  ) {
    // Already allow the serializer to handle a "normal" API response while keeping support for the current format
    // Whenever the API response is updated, this custom normalizeResponse() becomes redundant
    if (payload.results === undefined) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.normalizeResponse(
        store,
        primaryModelClass,
        payload,
        id,
        requestType,
      );
    }

    const transformedPayload = {
      issues: Object.values(payload.results)[0],
    };

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.normalizeResponse(
      store,
      primaryModelClass,
      transformedPayload,
      id,
      requestType,
    );
  }
}
